import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "~/app/store";
import { BinOrProductResult } from "~/features/inventory/AutostoreInventory";
import NavSearchInput from "~/features/navbar/NavSearchInput";

import { mixpanelTrack, useMixpanelPageName } from "~/lib/mixpanel-tracking";

import { setBinFilter } from "./cleaningBin.slice";

export function BinFilter() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const binFilter = useAppSelector((state) => state.cleaningBin.binFilter);
  const trackedPageName = useMixpanelPageName();

  const handleDebouncedSearch = (text: string | null) => {
    if (text) {
      mixpanelTrack({
        trackedPageName,
        type: "Search",
        label: "Search Bins",
        eventProperties: {
          "Search Text": text
        }
      });
    }
    return "autocomplete";
  };

  return (
    <Box
      id="cleaningbin-navbar-searchComponent"
      display="flex"
      flexGrow="1"
      justifyContent="center"
    >
      <NavSearchInput<BinOrProductResult>
        textInput={binFilter || ""}
        setTextInput={(text) => dispatch(setBinFilter(text))}
        searchPlaceholder={t("search bins")}
        autocompleteSearchCb={handleDebouncedSearch}
      />
    </Box>
  );
}
